import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotices } from '../data/content';
export function PurchaseToast() {
  const [index, setIndex] = useState<number>(0);
  const [visible, setVisible] = useState<boolean>(false);
  const [dismissed, setDismissed] = useState<boolean>(false);
  useEffect(() => {
    if (dismissed) return;
    const showTimer = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(showTimer);
  }, [dismissed, index]);
  useEffect(() => {
    if (!visible) return;
    const hideTimer = window.setTimeout(() => {
      setVisible(false);
      setIndex(prev => (prev + 1) % purchaseNotices.length);
    }, 7000);
    return () => window.clearTimeout(hideTimer);
  }, [visible]);
  if (dismissed) return null;
  const notice = purchaseNotices[index];
  return <AnimatePresence data-id="element-237" data-mp="b2sfctk3js79">
      {visible && <motion.aside key={notice.name} initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} aria-live="polite" className="fixed bottom-24 left-4 z-40 w-[min(320px,calc(100vw-2rem))] rounded-2xl border border-navy/10 bg-white p-4 shadow-pop sm:bottom-6" data-id="element-238" data-mp="b66ezu1dlnb0">
          <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso de compra verificada" className="absolute right-2 top-2 rounded-full p-1 text-navy/40 transition-colors hover:bg-cream hover:text-navy" data-id="element-239" data-mp="1bg9t8tg9pdvb">
            <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-240" data-mp="1p7el39de91v3" />
          </button>

          <p className="flex items-center gap-1.5 text-xs font-extrabold uppercase tracking-wide text-green-700" data-id="element-241" data-mp="1p9hl8m89gbdj">
            <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-242" data-mp="wr3wdc4wjzql" />
            Compra verificada
          </p>
          <p className="mt-1.5 text-sm font-bold text-navy" data-id="element-243" data-mp="201rhnnpo7ugn">{notice.name}</p>
          <p className="text-sm text-navy/75" data-id="element-244" data-mp="1zzoiad2mooz9">compró {notice.product}</p>
          <p className="mt-1 text-xs font-semibold text-navy/50" data-id="element-245" data-mp="1v2es2v7f09ad">
            hace {notice.minutes} minutos
          </p>
        </motion.aside>}
    </AnimatePresence>;
}